<script>
	import { onMount, onDestroy } from "svelte";
	import Shepherd from "shepherd.js";
	import "shepherd.js/dist/css/shepherd.css";
	import { yyyy, zzzz } from "./store.svelte";

	let tour;

	function startTour() {
		if (tour) {
			tour.start();
		}
	}

	onMount(() => {
		tour = new Shepherd.Tour({
			useModalOverlay: true,
			modalOverlayOpeningPadding: 20,
			defaultStepOptions: {
				cancelIcon: {
					enabled: true,
				},
				scrollTo: {
					behavior: "smooth",
					block: "center",
				},
				classes: "lvwr-tour-step",
				popperOptions: {
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, 25]
							}
						}
					]
				}
			},
		});

		// Welcome step
		tour.addStep({
			title: "Welcome to Livewire!",
			text:
				"Let me show you around the Livewire interface. You can exit this tour at any time by clicking the X.",
			buttons: [
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Your User Card",
			text:
				"This your user card. You can sign out, create a new livewire or change user settings here.",
			attachTo: {
				element: "#Usercard",
				on: "bottom",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});
		// Livewire cards

		tour.addStep({
			title: "Your Livewires",
			text:
				"This is a Livewire project. Each card is one livewire. It usually represents a a specific point in time of how the network was configured.",
			attachTo: {
				element: "#lvwr-01",
				on: "bottom",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Your Livewires",
			text: "This map shows the extent of the project area.",
			attachTo: {
				element: "#lvwr-01-map",
				on: "bottom",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Your Livewires",
			text:
				"This is information about a this livewire, name, owner and description.",
			attachTo: {
				element: "#lvwr-01-info",
				on: "bottom",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Your Livewires",
			text: "Click here to share, hide, fork and delete a livewire.",
			attachTo: {
				element: "#lvwr-01-more",
				on: "bottom",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Open a Livewire",
			text:
				'Click the "Open" button to view this Livewire on the map and continue the tour.',
			attachTo: {
				element: "#lvwr-01-open",
				on: "top",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
			],
		});

		tour.addStep({
			title: "Map View",
			text: "This is your Livewire working view.",
			buttons: [
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		// Create new livewire button
		tour.addStep({
			title: "Main Controls",
			text:
				"This is your main control bar. The Livewire's name is shown. You can exit, search and run applets from here",
			attachTo: {
				element: "#instigator",
				on: "right",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		tour.addStep({
			title: "Navigation Controls",
			text: "Use these controls to zoom in/out, toggle various layers and show your current location.",
			attachTo: {
				element: "#side-controls",
				on: "left",
			},
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Next",
					action: tour.next,
				},
			],
		});

		// Search/GPS controls
		tour.addStep({
			title: "Finished",
			text:
				"Thats it for now, its a pretty simple app. If you have any questions, email info@auchindown.com",
			
			buttons: [
				{
					text: "Back",
					action: tour.back,
				},
				{
					text: "Finish",
					action: tour.complete
				},
			],
		});

		// Layer controls

		// Listen for tour start event
		zzzz.on("start-help-tour", () => {
			startTour();
		});

		// Listen for tour advance event (when certain buttons are clicked)
		zzzz.on("tour-advance", () => {
			if (tour && tour.isActive()) {
				tour.next();
			}
		});
	});

	onDestroy(() => {
		if (tour) {
			tour.complete();
		}
		zzzz.off("start-help-tour");
		zzzz.off("tour-advance");
	});
</script>

<style>
	:global(.shepherd-modal-overlay-container) {
		z-index: 9998 !important;
	}

	:global(.shepherd-element) {
		z-index: 9999 !important;
	}

	:global(.shepherd-element.lvwr-tour-step) {
		background: white;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		min-width: 400px !important;
		max-width: 500px !important;
		width: 450px !important;
	}

	:global(.shepherd-element.lvwr-tour-step .shepherd-content) {
		width: 100% !important;
		min-width: 400px !important;
	}

	:global(.shepherd-element.lvwr-tour-step .shepherd-text) {
		width: 100% !important;
		white-space: normal !important;
	}

	:global(.lvwr-tour-step .shepherd-header) {
		background: linear-gradient(135deg, #ff3e00 0%, #ff6a33 100%);
		color: white;
		padding: 1rem;
		border-radius: 8px 8px 0 0;
	}

	:global(.lvwr-tour-step .shepherd-title) {
		color: #ff3e00;
		font-size: 1.2rem;
		font-weight: 600;
		font-family: 'Ubuntu', sans-serif;
	}

	:global(.lvwr-tour-step .shepherd-text) {
		padding: 1rem;
		font-size: 1rem;
		color: #333;
	}

	:global(.lvwr-tour-step .shepherd-footer) {
		padding: 0.75rem;
		border-top: 1px solid #e5e5e5;
	}

	:global(.lvwr-tour-step .shepherd-button) {
		background: #ff3e00;
		border: none;
		color: white;
		padding: 0.5rem 1rem;
		border-radius: 4px;
		cursor: pointer;
		font-size: 0.9rem;
		margin: 0 0.25rem;
		transition: background 0.2s;
	}

	:global(.lvwr-tour-step .shepherd-button:hover) {
		background: #e63600;
	}

	:global(.lvwr-tour-step .shepherd-button-secondary) {
		background: #f0f0f0;
		color: #333;
	}

	:global(.lvwr-tour-step .shepherd-button-secondary:hover) {
		background: #e0e0e0;
	}

	:global(.lvwr-tour-step .shepherd-cancel-icon) {
		color: #999;
	}

	:global(.shepherd-arrow) {
		fill: white;
	}
</style>
